module.exports = __webpack_public_path__ + "img/signin-logo.82b654e3.png";